export const range = (size: number, startAt = 0) => {
  return Array(size)
    .fill(0)
    .map((_, idx) => idx + startAt) as Array<number>;
};
